export default __webpack_public_path__ + "static/datasec-c396232017876efafbe15d2bee6c6072.jpg";